import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SponsorApplicationRoutingModule } from './sponsor-application-routing.module';
import { HeaderModule } from '../../shared/components/header/header.module';
import { SponsorApplicationComponent } from './sponsor-application.component';
import { FooterModule } from '../../shared/components/footer/footer.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    SponsorApplicationComponent
  ],
  imports: [
    CommonModule,
    SponsorApplicationRoutingModule, 
    HeaderModule, 
    FooterModule, 
    FormsModule, 
    ReactiveFormsModule
  ], 
  exports: [
    SponsorApplicationComponent
  ]
})
export class SponsorApplicationModule { }
